module.exports = __webpack_public_path__ + "img/playicon.705b854.png";